<template>
  <div v-if="isWelcomeLogin">
    <div class="col-sm-12 header-component mb15 flex-row plr16">
      <skip-login :skip-text="getSkipLoginText" />
    </div>
    <div class="plr16">
      <div>
        <img :src="staticImgBaseUrl + '/images/global/logoLgTemplate.svg'" />
      </div>

      <div class="login-benefit-container">
        <div class="login-benefit-item">
          <i
            :class="loginProps?.loginBenefit1Icon"
            class="fs-24 color-grey-light"
          ></i>
          <div class="login-benefit-text-sm item-1">
            {{ loginProps?.loginBenefit1Text }}
          </div>
        </div>
        <div class="login-benefit-item">
          <i
            :class="loginProps?.loginBenefit2Icon"
            class="fs-24 color-grey-light"
          ></i>
          <div class="login-benefit-text-sm item-2">
            {{ loginProps?.loginBenefit2Text }}
          </div>
        </div>
        <div class="login-benefit-item">
          <i
            :class="loginProps?.loginBenefit3Icon"
            class="fs-24 color-grey-light"
          ></i>
          <div class="login-benefit-text-sm item-3">
            {{ loginProps?.loginBenefit3Text }}
          </div>
        </div>
      </div>
    </div>
    <hr class="mb0 mt0 mlr0" />
  </div>
</template>

<script>
import { keyMapsMutation, keyMapsAction } from "../helpers/storeKeys";
import { clientPlatform, staticImgBaseUrl } from "../config/apiEndpoints";
import { LoginStates } from "../helpers/loginStateConstants";
import SkipLogin from "./SkipLogin.vue";

export default {
  name: "LoginInfo",
  components: { SkipLogin },
  props: ["moduleProps", "propsData"],
  data() {
    return { modulePropsData: {}, clientPlatform, staticImgBaseUrl };
  },
  async mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};
  },
  methods: {
    closeWelcomeLoginModal(e) {
      e.stopPropagation();
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_WELCOME_SCREEN_ON_PAGELOAD,
        false
      );
      if (clientPlatform == "Web") {
        this.$store.commit(
          keyMapsMutation.UPDATE_SHOW_PROFILE_DRAWER_MODAL,
          false
        );
      }
      document.body.classList.remove("body-stop-scroll-mobile");
    },
  },
  computed: {
    isWelcomeLogin() {
      return clientPlatform == "Web"
        ? this.$store.state.Auth.currentLoginState ===
            LoginStates.welcomeLogin &&
            this.$store.state.Auth.showProfileDrawerModal
        : this.$store.state.Auth.currentLoginState === LoginStates.welcomeLogin;
    },
    loginProps() {
      return Object.keys(this.modulePropsData).length
        ? this.modulePropsData
        : this.$store.state.Auth.loginProps;
    },
    getSkipLoginText() {
      return "Skip";
      // if (!LocalStorageFunc.getSessionStorageKey("previousScreenName", "")) {
      //   return "Skip";
      // } else {
      //   return "Cancel";
      // }
    },
  },
};
</script>
